import axios from 'axios';

export const getSireneInfo = async (siret: string) => {
    const response = await axios.get(`/organizations/data-from-sirene-api/${siret}`);
    return response.data.data;
};
